import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	function initializeSlider(selector) {
		const sliderElements = document.querySelectorAll(selector);
		// If Sliderelemnt can not be find, exit the function
		if (!sliderElements) return;

		if (sliderElements.length > 0) {
			sliderElements.forEach(function (sliderElement) {
				let splideInstance; // Declare splideInstance here, in the forEach loop's scope

				if (sliderElement.splide) {
					// Check if a Splide instance already exists on sliderElement and destroys it before initializing a new one.
					sliderElement.splide.destroy();
				}

				// Prevent duplicate initialization
				if (sliderElement.classList.contains("is-initialized")) return;
				sliderElement.classList.add("is-initialized");

				splideInstance = new Splide(sliderElement, {
					type: "slide",
					perPage: 1,
					perMove: 1,
					//autoplay: true,
					rewind: true,
					gap: "2.4rem",
					pauseOnHover: true,
					arrows: false,
					pagination: false,
					mediaQuery: "min",
					breakpoints: {
						768: {
							perPage: 2,
						},
						996: {
							perPage: 3,
						},
						1920: {
							perPage: 4,
						},
					},
				}).mount();

				// Get CTA values for slider's speed
				function getSpeed(element) {
					if (element.classList.contains("800")) return 800;
					if (element.classList.contains("1200")) return 1200;
					return 400; // Default speed
				}

				// Get CTA values for the number of slides
				function getSlidesNumber(element) {
					const slidesClass = [...element.classList].find((cls) =>
						cls.startsWith("slides-")
					);
					let slidesNumber = slidesClass
						? parseInt(slidesClass.replace("slides-", ""), 10) || 1
						: 1;

					return Math.min(Math.max(slidesNumber, 1), 4);
				}

				//
				// If custom arrows need to be added
				//
				if (sliderElement.querySelector(".custom-arrows")) {
					// Create custom arrow elements if they don't exist
					if (!sliderElement.querySelector(".custom-prev")) {
						const prevButton = document.createElement("button");
						prevButton.classList.add("custom-prev");
						prevButton.textContent = "Prev"; // Or use an icon
						sliderElement.appendChild(prevButton);
					}
					if (!sliderElement.querySelector(".custom-next")) {
						const nextButton = document.createElement("button");
						nextButton.classList.add("custom-next");
						nextButton.textContent = "Next"; // Or use an icon
						sliderElement.appendChild(nextButton);
					}

					const prevButton =
						sliderElement.querySelector(".custom-prev");
					const nextButton =
						sliderElement.querySelector(".custom-next");

					// add event listener if buttons exists
					if (prevButton) {
						prevButton.addEventListener("click", () => {
							splideInstance.go("-1");
						});
					}
					if (nextButton) {
						nextButton.addEventListener("click", () => {
							splideInstance.go("+1");
						});
					}

						// Function to toggle arrows visibility
						const toggleArrows = () => {
							const totalSlides = splideInstance.length;
							const perPage = splideInstance.options.perPage;
							if (prevButton && nextButton) {
								if (totalSlides <= perPage) {
									prevButton.style.display = "none";
									nextButton.style.display = "none";
								} else {
									prevButton.style.display = "";
									nextButton.style.display = "";
								}
							}
						};
	
						// Run once after mount
						toggleArrows();
	
						// Also re-check on resize (because perPage may change)
						splideInstance.on("resize", () => toggleArrows());
						
				}
			});
		}
	}

	//Initialize slider for cards
	initializeSlider(".resource-carousel");
});
